import { Injectable, Inject } from '@angular/core';
import { Reservation, ReservationSubItem } from '../model/reservation.model';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { SportType } from '../model/sport-type.model';
import { SkillLevel } from '../model/skill-level.model';
import { tick } from '@angular/core/testing';
import { LessonType } from '../model/lesson-type.model';
import { ReservationStatus } from '../model/reservation-status.model';
import { EquipmentTimeSlot } from '../model/equipment-time-slot.model';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) {

  }
  sportTypes: SportType[];
  skillLevels: SkillLevel[];
  lessonTypes: LessonType[];
  CreateReservation(reservation: Reservation){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const body = JSON.stringify(reservation);
    return this.httpClient.post<Reservation>(this.baseUrl + '/api/Reservation/Create', body, httpOptions);
  }

  getSportTypes(): SportType[]{
    this.sportTypes = []
    this.sportTypes.push(new SportType(0,"ski", "ski"))
    this.sportTypes.push(new SportType(1,"snowboard", "snowboard"))
    return this.sportTypes;
  }

  getSkillLevels(): SkillLevel[]{
    this.skillLevels=[];
    this.skillLevels.push(new SkillLevel(0,"osnovni","osnovni"));
    this.skillLevels.push(new SkillLevel(1,"srednji","srednji"));
    this.skillLevels.push(new SkillLevel(2,"napredni","napredni"));
    return this.skillLevels;
  }
  getLessonTypes(): LessonType[]{
    this.lessonTypes=[];
    this.lessonTypes.push(new LessonType(0,"individual","individual"));
    this.lessonTypes.push(new LessonType(1,"group2","group2"));
    this.lessonTypes.push(new LessonType(2,"group4","group4"));
    this.lessonTypes.push(new LessonType(3,"demo","demo"));
    return this.lessonTypes;
  }

  GetAll(isLessonReservation): Observable <Reservation[]>{
    return this.httpClient.get<Reservation[]>(`${this.baseUrl}/api/Reservation/GetAll/${isLessonReservation}`);
  }

  GetByUserId(userId,isLessonReservation): Observable <Reservation[]>{
    let params = new HttpParams();
    params = params.append('userId', userId);
    params = params.append('isLessonReservation', isLessonReservation);
    return this.httpClient.get<Reservation[]>(this.baseUrl+ '/api/Reservation/GetByUserId', {params});
  }
  GetReservationSubItemsById(id): Observable <ReservationSubItem[]> {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.httpClient.get<ReservationSubItem[]>(this.baseUrl + '/api/Reservation/GetReservationSubItemsById', {params});
  }

  editReservationStatus(id: number, status: number) {
    return this.httpClient.post<boolean>(`${this.baseUrl}/api/Reservation/EditStatus/${id}/${status}`, '');
  }

  getById(id): Observable <Reservation> {
    return this.httpClient.get<Reservation>(this.baseUrl + '/api/Reservation/GetById/' + id);
  }

  getByIdWithItems(id): Observable<Reservation> {
    return this.httpClient.get<Reservation>(this.baseUrl + '/api/Reservation/GetByIdWithItems/' + id);
  }

  getByIdWithOrderItems(id): Observable<Reservation> {
    return this.httpClient.get<Reservation>(this.baseUrl + '/api/Reservation/GetByIdWithOrderItems/' + id);
  }

  createOrderItems(reservation: Reservation): Observable<Reservation> {
    return this.httpClient.post<Reservation>(this.baseUrl + '/api/Reservation/CreateOrderItems', reservation);
  }

  getReservedEquipmentTimeSlots(groupTypeId?): Observable<EquipmentTimeSlot[]> {
    let params = new HttpParams();
    params = params.append('groupTypeId', groupTypeId);
    return this.httpClient.get<EquipmentTimeSlot[]>(this.baseUrl + '/api/Reservation/GetReservedEquipmentTimeSlots',{params});
  }
}
